import React, { createContext, useContext, useEffect, useState } from 'react';

const LocalStorageContext = createContext();

export const LocalStorageProvider = ({ children }) => {
  const [localStorageValue, setLocalStorageValue] = useState({});

  const updateLocalStorageValue = (key, value) => {
    setLocalStorageValue((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key) {
        updateLocalStorageValue(event.key, event.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <LocalStorageContext.Provider value={{ localStorageValue, updateLocalStorageValue }}>
      {children}
    </LocalStorageContext.Provider>
  );
};

export const useLocalStorage = (key) => {
  const { localStorageValue, updateLocalStorageValue } = useContext(LocalStorageContext);

  const value = localStorageValue[key] || localStorage.getItem(key);

  const setValue = (newValue) => {
    localStorage.setItem(key, newValue);
    updateLocalStorageValue(key, newValue);
  };

  return [value, setValue];
};